module.exports = __webpack_public_path__ + "dlssrvtyy/img/thai_slider-5.jpg?80aa7a8c";